import { defineStore } from 'pinia';
import { ReportPreMadeTemplate } from '@/services/api/resources/analytics-builder/constants';
import { ReportRecordData } from '@/services/api/resources/analytics-builder/model';

interface ReportTemplateState {
  templateType: ReportPreMadeTemplate | null;
  template: ReportRecordData | null;
}

export const useReportTemplateStore = defineStore('reportTemplate', {
  state: (): ReportTemplateState => ({
    templateType: null,
    template: null,
  }),
  actions: {
    setTemplate(type: ReportPreMadeTemplate, template: ReportRecordData) {
      this.templateType = type;
      this.template = template;
    },
  },
});
